import { Form, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import ListContainer from "../../modules/partner/containers/List";
import PrimaryButton from "../Buttons/PrimaryButton";
import PartnerForm from "../Forms/Partners/Partner";
import withPage from "./withPage";
import "./Partners.scss";
import SecondaryButton from "../Buttons/SecondaryButton";
import { Link } from "react-router-dom/cjs/react-router-dom";

const PartnersPage = ({ isFetching, partners, doGetAllPartners, doCreatePartner, doUpdatePartner }) => {
  const [form] = Form.useForm();
  const [state, setState] = useState({
    visibleModal: false,
    action: "",
    partner: null,
  });

  useEffect(() => {
    doGetAllPartners({});
  }, []);

  const handleClickAction = (action, item) => {
    form.setFieldsValue({
      name: item?.name,
      email: item?.email,
      status: item?.status,
      password: null,
    });
    setState({
      ...state,
      action,
      partner: item,
      visibleModal: true,
    });
  };

  const handleOnFinish = async values => {
    if (state.partner) {
      await doUpdatePartner({ id: state.partner._id, ...values });
    } else {
      await doCreatePartner(values);
      await doGetAllPartners({});
    }
    handleCancel();
  };

  const handleCancel = () => {
    setState({ ...state, visibleModal: false });
  };

  return (
    <Spin spinning={isFetching}>
      <div className="Content PartnersPage">
        <div className="ContentHeader">
          <div className="HeaderTitle">Partners</div>
          <div className="HeaderToolBar">
            <div className="ToolBarButtons">
              {/* <Button className="FilterButton" type="primary">
                Filter <ReactSVG className="icon" src="/icons/filter.svg" />
              </Button> */}
              <PrimaryButton
                label="New Partner"
                className="NewButton"
                onClick={() => {
                  handleClickAction("new", null);
                }}
                icon={<ReactSVG className="icon" src="/icons/add.svg" />}
              />
            </div>
          </div>
        </div>
        <div className="ContentMain">
          {partners?.map(partner => {
            const company = partner?.companies[0].company;
            return (
              <div className="item" key={partner._id}>
                <div className="item__logo">
                  <img src={`${company?.logo ? company?.logo : "/logo.svg"}`} alt="logo" />
                </div>
                <div className="item__info">
                  <div className="item__info__top">
                    <div className="item__info__details">
                      <span className={`item__info__status ${partner?.status ? "active" : "inactive"}`}>
                        {partner?.status ? "Active" : "Inactive"}
                      </span>
                      <span className="item__info__name">{partner?.name}</span>
                      <span className="item__info__email">{partner?.email}</span>
                    </div>
                    <div className="item__info__actions">
                      <SecondaryButton
                        label={"Export"}
                        size="small"
                        icon={<ReactSVG className="icon" src="/icons/export.svg" />}
                      />
                      <PrimaryButton
                        label={"Edit"}
                        size="small"
                        icon={<ReactSVG className="icon" src="/icons/edit-small.svg" />}
                        onClick={() => handleClickAction("edit", partner)}
                      />
                    </div>
                  </div>
                  <div className="item__info__bottom">
                    <div className="item__info__bottom__item companies">
                      <Link to={`/companies?companyPartnerId=${partner.companies[0].company._id}`}>
                        <div className="quantity">{company?.partnerTotalCompanies}</div>
                      </Link>
                      <div className="label">Companies</div>
                    </div>
                    <div className="item__info__bottom__item route-plans">
                      <div className="quantity">{company?.partnerTotalRoutePlans}</div>
                      <div className="label">Route Plans</div>
                    </div>
                    <div className="item__info__bottom__item drivers">
                      <div className="quantity">{company?.partnerTotalDrivers}</div>
                      <div className="label">Drivers</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <Modal open={state.visibleModal} onCancel={handleCancel} footer={[]} width={370}>
          <PartnerForm
            form={form}
            isFetching={isFetching}
            partner={state.partner}
            handleSubmit={handleOnFinish}
            handleCancel={handleCancel}
          />
        </Modal>
      </div>
    </Spin>
  );
};

export default withPage(ListContainer(PartnersPage));
